import Indicador from "..";
import { PragaSoloParamFields } from "./components/PragaSoloParamFields";
import PragaSoloEditFields from "./components/PragaSoloEditFields";
import pragaSoloReport from "./reports";
import pragaSoloReportSummary from "./reports/summary";
import { getTalhaoNomeDisplay, getTalhaoAreaDisplay } from "entity/Indicador/reports/talhaoDisplay";

export default class PragaSolo extends Indicador {
    static get fullName() {
        return "Praga de Solo";
    }

    static get abbrev() {
        return "PragaSolo";
    }

    static get quantifierMeta() {
        return "%";
    }

    static paramFields(tipoIndicadorField = "") {
        return <PragaSoloParamFields tipoIndicadorField={tipoIndicadorField} />;
    }

    static getEditFields(visita, isNew, TipoClass) {
        return <PragaSoloEditFields visita={visita} TipoClass={TipoClass} />;
    }

    async renderReport(visita) {
        return pragaSoloReport(this, visita);
    }

    async renderReportSummary(visita, tipoName) {
        return pragaSoloReportSummary(this, visita, tipoName);
    }

    static calcConformidade(apontamento, params) {
        const f = parseFloat;

        if (!apontamento.coletas || !params || apontamento.coletas.length === 0) {
            return 0;
        }

        let totalTocosAvaliados = 0;
        let totalTocosDanificados = 0;

        for (const coleta of apontamento.coletas) {
            let pragaHyponeuma = 0;
            let outrasPragas = 0;
            let pragaMigdolus = 0;
            let pragaSphenophorus = 0;

            if (coleta.pragaHyponeuma) {
                pragaHyponeuma = f(coleta.pragaHyponeuma);
            }
            if (coleta.outrasPragas) {
                outrasPragas = f(coleta.outrasPragas);
            }
            if (coleta.pragaMigdolus) {
                pragaMigdolus = f(coleta.pragaMigdolus);
            }
            if (coleta.pragaSphenophorus) {
                pragaSphenophorus = f(coleta.pragaSphenophorus);
            }

            coleta.tocosDanificados = pragaHyponeuma + outrasPragas + pragaMigdolus + pragaSphenophorus;

            if (coleta.tocosAvaliados) totalTocosAvaliados += f(coleta.tocosAvaliados);
            if (coleta.tocosDanificados) totalTocosDanificados += f(coleta.tocosDanificados);
        }

        if (apontamento.coletas.length && totalTocosAvaliados === 0) {
            apontamento.totalTocosAvaliados = 0;
            apontamento.totalTocosDanificados = 0;
            return 0;
        } else {
            apontamento.totalTocosAvaliados = totalTocosAvaliados;
            apontamento.totalTocosDanificados = totalTocosDanificados;
            apontamento.conformidade = (totalTocosDanificados * 100) / totalTocosAvaliados;

            return apontamento.conformidade;
        }
    }

    static getConformidadeStatus(conformidade, meta) {
        if (conformidade <= parseFloat(meta)) return "Bom";
        else return "Ruim";
    }

    static getTableRelApontamentos(paramsCliente, IndicadorClass) {
        return [
            { title: "Data", width: "auto", getValue: (a) => a.dataRef.split("-").reverse().join("/") },
            { title: "Laudo", field: "laudoRef.sequencialIndex", width: 28 },
            { title: "Cod.", field: "laudoRef.fazenda.codFazenda", width: "auto" },
            { title: "Fazenda", field: "laudoRef.fazenda.nomeFazenda" },
            {
                title: "Talhão",
                field: "talhao.nome",
                getValue: (a) => getTalhaoNomeDisplay(a),
            },
            {
                title: "Área (ha)",
                field: "talhao.area",
                getValue: (a) => getTalhaoAreaDisplay(a),
            },
            { title: "Variedade", field: "variedade.variedade", width: "auto" },
            { title: "Total de Tocos Avaliados", width: "auto", field: "totalTocosAvaliados" },
            { title: "Total de Tocos Danificados", width: "auto", field: "totalTocosDanificados" },
            {
                title: "Conf.(%)",
                field: "conformidade",
                width: "auto",
                getColor: (a) => {
                    return IndicadorClass.getColorStatus(
                        IndicadorClass.getConformidadeStatus(a.conformidade, paramsCliente?.meta),
                    );
                },
            },
        ];
    }

    static getResultStr(apontamento) {
        return (
            "Total de Tocos Avaliados: " +
            apontamento.totalTocosAvaliados +
            " e Total de Tocos Danificados: " +
            apontamento.totalTocosDanificados
        );
    }
}
